import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FiProductsService } from '@app/core/services/fi-products.service';
import { IFiProducts } from '@app/models/fi-products.model';
import { IUserAccMarketPlace } from '@app/models/user-info.model';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { concatMap, shareReplay, tap } from 'rxjs/operators';
import { Constants } from 'src/app/constants';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  constructor(
    private http: HttpClient,
    private fiProductsService: FiProductsService,
    private cookieService: CookieService
  ) { }

  userInfo$: Observable<IUserAccMarketPlace>;
  /**
   * Gets portal account id
   * @returns portal account id
   */
  public getUserInfo(): Observable<IUserAccMarketPlace> {
    const bearerToken = localStorage.getItem('access_token');

    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${bearerToken}`
    });

    if (!this.userInfo$) {
      this.userInfo$ = this.http
        .get<IUserAccMarketPlace>(Constants.appConfiguration.accountsApiRoot, {
          headers
        })
        .pipe(
          tap(res => localStorage.setItem('account', JSON.stringify(res))),
          shareReplay()
        );
    }
    return this.userInfo$;
  }

  /**
   *
   * @returns Observable that would resolve to products for current user
   *
   */
  getProductsForUser(): Observable<IFiProducts> {
    return this.getUserInfo().pipe(
      concatMap(userInfo => this.fiProductsService.getFiProducts(userInfo))
    );
  }

  /*
  Returns Index of Element which matches with Cookie AccountID
  @param user --singleUser if its UE or Array if UD  
  @returns Index --0 if UE or index of matched AccountID if UD 
*/
  getAccountIndex(user: IUserAccMarketPlace | IUserAccMarketPlace[]): number {
    const users = Array.isArray(user) ? user : [user];
    const cookieAccountId = this.cookieService.get('account');
    if (users?.length === 1 || !cookieAccountId) {
      return 0;
    }
    const index = users?.findIndex(
      (user: IUserAccMarketPlace) =>
        Number(user.AccountId) === Number(cookieAccountId)
    );
    return index >= 0 ? index : 0;
  }
}
